<template>
  <div class="py-5 px-2 pt-1">
    <pop-up
      :active.sync="popUp"
      @close="$router.push({ name: 'VesselLineUpList' })"
      @ok="$router.push({ name: 'VesselLineUpList' })"
    >
      You have successfully {{ isCreate() ? 'add' : 'edit' }} vessel line up
    </pop-up>
    <log-sidecar
      :is-shown.sync="isLogShown"
      :barge-log-data="vesselLogItems"
    />
    <base-custom-modal :is-shown.sync="isEditReasonModalShown">
      <template #title>
        <span class="font-semibold text-lg">Reason</span>
      </template>

      <template #body>
        <div class="flex flex-col">
          <span class="font-semibold">Reason</span>
          <vs-textarea
            v-model="reason"
            placeholder="Enter reason here"
            class="reason-textarea"
          />
        </div>
      </template>

      <template #footer>
        <div class="flex flex-row justify-end">
          <vs-button
            type="border"
            color="secondary"
            class="w-32 mr-2 font-semibold"
            @click="isEditReasonModalShown = false"
          >
            Cancel
          </vs-button>
          <vs-button
            ref="editButton"
            type="filled"
            color="secondary"
            class="w-32 ml-2 font-semibold vs-con-loading__container"
            @click="submit"
          >
            Submit
          </vs-button>
        </div>
      </template>
    </base-custom-modal>
    <div class="flex flex-wrap flex-row justify-between items-center px-3">
      <p class="font-semibold text-3xl">
        {{ pageSubTitle() }} Vessel Line Up
      </p>
      <div class="flex flex-row">
        <vs-button
          v-if="isDetail() && isUserCanAccessMenu(permission.name, 'edit')"
          class="button shadow-secondary ml-6"
          color="secondary"
          @click="$router.push({ name: 'VesselLineUpEdit', params: { id: $route.params.id || vesselLineUpId } })"
        >
          Edit
        </vs-button>
        <div class="mx-4 divider" />
        <vs-button
          v-show="isDetail()"
          class="button shadow-secondary"
          color="secondary"
          @click="isLogShown = !isLogShown"
        >
          Log
        </vs-button>
      </div>
    </div>
    <div class="flex flex-wrap flex-row">
      <div
        class="mt-6 px-3"
        v-for="(card, cardIndex) of form"
        :key="`card-${cardIndex+1}`"
        :id="`card-${cardIndex+1}`"
        :class="[ card.key === 'jbg' || card.key === 'ktd' ? 'w-1/2' : 'w-full' ]"
      >
        <div class="bg-white rounded-2xl p-6">
          <span
            v-if="card.title"
            class="flex flex-row justify-between text-xl font-semibold"
          >
            {{ card.title }}
            <span
              v-if="card.key === 'third_party'"
              class="bg-danger-accent py-1 px-2 rounded-lg text-base text-danger"
            >
              3rd Party data will dynamic follows the column in excel
            </span>
          </span>

          <div
            v-if="card.inputField.length"
            class="flex flex-wrap flex-row items-center justify-start mx-min-3"
            :class="[ card.title ? 'mt-2' : 'mt-min-4' ]"
          >
            <template v-for="(input, inputIndex) of card.inputField">
              <div
                v-if="input.key !== 'loading_plan'"
                class="flex flex-col px-3 mt-4"
                :class="[
                  input.key === 'remark' || card.inputField.length === 1 ? 'w-full' : 'w-1/2',
                  input.key === 'lay'|| input.key === 'can' ? 'w-1/4' : ''
                ]"
                :key="`card-${inputIndex+1}`"
                :id="`card-${inputIndex+1}`"
              >
                <label class="inline-block text-sm font-semibold text-grey p-0 mb-1">
                  {{ input.title }}
                </label>
                <vs-textarea
                  v-if="input.key === 'remark'"
                  class="min-w-full"
                  v-model="input.value"
                  :placeholder="input.placeholder"
                  :disabled="isDetail()"
                />
                <date-picker
                  v-else-if="input.isDate"
                  class="min-w-full"
                  v-model="input.value"
                  :class="{ 'is-not-valid': input.hasOwnProperty('isValid')
                    ? !input.isValid
                    : false
                  }"
                  :type="input.type"
                  :value-type="input.valueType"
                  :format="input.format"
                  :placeholder="input.placeholder"
                  :disabled-date="(date) => disabledDate(input.key, date)"
                  :disabled-time="(date) => disabledTime(input.key, date, input.value)"
                  :disabled="isDetail() || input.isDisabled"
                  @input="selected(input)"
                />
                <select-with-search
                  v-else-if="!input.isFreeInput"
                  class="min-w-full"
                  v-model="input.value"
                  :class="{ 'is-not-valid': input.hasOwnProperty('isValid')
                    ? !input.isValid
                    : false
                  }"
                  :hide-search="!input.canSearch"
                  :placeholder="input.placeholder"
                  :disabled="isDetail() || input.isDisabled"
                  :options="options[input.key]"
                  @input="selected(input)"
                />
                <vs-input
                  v-else-if="input.isFreeInput && !input.isNumber"
                  class="min-w-full"
                  v-model="input.value"
                  :class="{ 'is-not-valid': input.hasOwnProperty('isValid')
                    ? !input.isValid
                    : false
                  }"
                  :placeholder="input.placeholder"
                  :disabled="isDetail() || input.isDisabled"
                />
                <autonumeric
                  v-else-if="input.isFreeInput && input.isNumber"
                  class="min-w-full"
                  v-model="input.value"
                  :class="{ 'is-not-valid': input.hasOwnProperty('isValid')
                    ? !input.isValid
                    : false
                  }"
                  :options="numericOptions"
                  :placeholder="input.placeholder"
                  :disabled="isDetail() || input.isDisabled"
                >
                  <div
                    v-if="input.haveUnit"
                    class="h-full px-5 flex flex-col justify-center rounded-r-lg bg-primary"
                  >
                    <span class="text-white">mt</span>
                  </div>
                </autonumeric>
              </div>
              <div
                v-else
                class="rounded-2xl w-full p-6 mt-6 mb-4 mx-3 border border-primary-accent"
                :key="`card-${inputIndex+1}`"
                :id="`card-${inputIndex+1}`"
              >
                <span class="text-xl font-semibold">{{ input.title }}</span>
                <div class="flex flex-wrap mx-min-3 mt-2">
                  <div
                    class="flex w-1/2 px-3 mt-4"
                    v-for="i in 4"
                    :key="`${input.key}-${i}`"
                    :id="`${input.key}-${i}`"
                  >
                    <date-picker
                      v-model="input.value[i-1]"
                      class="min-w-full"
                      :type="input.type"
                      :value-type="input.valueType"
                      :format="input.format"
                      :placeholder="input.placeholder"
                      :label="input.label[i-1]"
                      :disabled="true"
                    />
                  </div>
                </div>
              </div>
            </template>
          </div>
          <no-data
            v-else
            message="Please select End User first"
          />
        </div>
      </div>
    </div>
    <div class="mt-6 px-3 flex items-center justify-end">
      <vs-button
        :class="`button ${isBusy && 'cursor-not-allowed animate-pulse'}`"
        type="border"
        color="secondary"
        :disabled="isBusy"
        @click="$router.push({ name: 'VesselLineUpList' })"
      >
        {{ isDetail() ? 'Back' : 'Cancel' }}
      </vs-button>
      <vs-button
        v-if="isCreate()"
        :class="`button shadow-secondary ml-6 ${isBusy && 'cursor-not-allowed animate-pulse'}`"
        color="secondary"
        @click="submit"
        :disabled="isBusy"
      >
        Submit
      </vs-button>
      <vs-button
        v-if="!isDetail() && !isCreate()"
        :class="`button shadow-secondary ml-6 ${isBusy && 'cursor-not-allowed animate-pulse'}`"
        color="secondary"
        :disabled="isBusy"
        @click="isEditReasonModalShown = true"
      >
        Save
      </vs-button>
      <vs-button
        v-if="isDetail() && isUserCanAccessMenu(permission.name, 'edit')"
        :class="`button shadow-secondary ml-6 ${isBusy && 'cursor-not-allowed animate-pulse'}`"
        color="secondary"
        :disabled="isBusy"
        @click="$router.push({ name: 'VesselLineUpEdit', params: { id: $route.params.id || vesselLineUpId } })"
      >
        Edit
      </vs-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Autonumeric from '@/components/autonumeric'
import BaseCustomModal from '@/components/baseCustomModal'
import DatePicker from '@/components/datePicker'
import LogSidecar from '@/components/logSidecar'
import NoData from '@/components/noData'
import PopUp from '@/components/popUp'
import SelectWithSearch from '@/components/selectWithSearch'
import { PAGE_TITLE } from '@/fixtures/Constants'
import VesselLineUpForm from '@/fixtures/vessel-line-up-form.json'

export default {
  metaInfo() {
    return {
      title: `${PAGE_TITLE} ${this.pageSubTitle()} Vessel Line Up`
    }
  },
  components: {
    Autonumeric,
    BaseCustomModal,
    DatePicker,
    LogSidecar,
    NoData,
    SelectWithSearch,
    PopUp
  },
  data() {
    return {
      isLogShown: false,
      isEditReasonModalShown: false,
      vesselLogItems: [],
      form: JSON.parse(JSON.stringify(VesselLineUpForm.form)),
      reason: '',
      options: {
        end_user: [],
        loading_facility_id: [],
        flf_fc_nominate_id: [],
        agency_id: [],
        vessel_type_id: [],
        status: [
          { text: 'Incoming Vessel', value: 'Incoming Vessel' },
          { text: 'Complete', value: 'Complete' },
          { text: 'Waiting Load', value: 'Waiting Load' },
          { text: 'Loading', value: 'Loading' }
        ]
      },
      numericOptions: {
        allowDecimalPadding: false,
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        roundingMethod: 'U',
        minimumValue: '0'
      },
      popUp: false,
      isBusy: false
    }
  },
  mounted() {
    this.initialize()
  },
  computed: {
    ...mapGetters({
      vesselLineUpId: 'VesselLineUp/vesselLineUpId',
      vesselLineUpDetail: 'VesselLineUp/vesselLineUpDetail',
      vesselLineUpLog: 'VesselLineUp/vesselLineUpLog',
      endUserList: 'VesselLineUp/endUserList',
      endUserDetail: 'VesselLineUp/endUserDetail',
      agencies: 'VesselLineUp/agencies',
      loadingFacilities: 'VesselLineUp/loadingFacilities',
      flfFcNominates: 'VesselLineUp/flfFcNominates',
      vesselTypes: 'VesselLineUp/vesselTypes'
    }),
    permission() {
      return { page: this.$route.meta.permission.page, name: this.$route.meta.permission.name }
    }
  },
  watch: {
    endUserList: {
      handler(val) {
        if (!this.isEmpty(val)) {
          this.options.end_user = val
        }
      }
    },
    endUserDetail: {
      immediate: true,
      handler(val) {
        if (!this.isEmpty(val) && !this.isDetail()) {
          this.transformDataToForm(val)
        }
      }
    },
    vesselLineUpDetail: {
      immediate: true,
      handler(val) {
        if (!this.isEmpty(val) && !this.isCreate()) {
          this.getEndUserList(val.expected_month)
          if (this.isEmpty(this.endUserList) || this.isEmpty(this.options.end_user)) {
            this.options.end_user = [
              { value: val.end_user, text: val.end_user }
            ]
          }
          this.transformDataToForm(val)
        }
      }
    },
    vesselLineUpLog: {
      immediate: true,
      handler(val) {
        if (!this.isEmpty(val) && this.isDetail()) {
          this.vesselLogItems = val
        }
      }
    },
    agencies: {
      immediate: true,
      handler(val) {
        if (!this.isEmpty(val)) {
          this.options.agency_id = val
        }
      }
    },
    loadingFacilities: {
      immediate: true,
      handler(val) {
        if (!this.isEmpty(val)) {
          this.options.loading_facility_id = val
        }
      }
    },
    flfFcNominates: {
      immediate: true,
      handler(val) {
        if (!this.isEmpty(val)) {
          this.options.flf_fc_nominate_id = val
        }
      }
    },
    vesselTypes: {
      immediate: true,
      handler(val) {
        if (!this.isEmpty(val)) {
          this.options.vessel_type_id = val
        }
      }
    },
    isEditReasonModalShown: function(val) {
      if (!val) {
        this.reason = ''
      }
    }
  },
  methods: {
    async initialize() {
      if (!this.isCreate()) {
        await this.getVesselLineUpDetail()
        await this.getVesselLineUpLog()
      }
      await this.getAgencies()
      await this.getLoadingFacilities()
      await this.getFlfFcNominates()
      await this.getVesselTypes()
    },
    async getAgencies() {
      await this.$store.dispatch('VesselLineUp/getAgencies')
    },
    async getLoadingFacilities() {
      await this.$store.dispatch('VesselLineUp/getLoadingFacilities')
    },
    async getFlfFcNominates() {
      await this.$store.dispatch('VesselLineUp/getFlfFcNominates')
    },
    async getVesselTypes() {
      await this.$store.dispatch('VesselLineUp/getVesselTypes')
    },
    async getEndUserList(value) {
      await this.$store.dispatch('VesselLineUp/getEndUserList', {
        expected_month: value
      })
    },
    async selected(item) {
      if (item.key === 'end_user') {
        await this.$store.dispatch('VesselLineUp/getEndUserDetail',
          this.options.end_user.find(opt => opt.text === item.value)['id']
        )
      }

      if (item.key === 'expected_month') {
        if (!item.value) {
          this.options.end_user = []
          return
        }
        await this.getEndUserList(
          this.moment(item.value, ['MMM-YYYY']).format('YYYY-MM-DDTHH:mm:ss.SSSSZ')
        )
      }
    },
    async getVesselLineUpDetail() {
      try {
        await this.$store.dispatch('VesselLineUp/getVesselLineUpDetail', this.$route.params.id || this.vesselLineUpId)
      } catch (e) {
        this.showFailedNotification(this, 'Failed to fetch VLU detail, please try again')
      }
    },
    async getVesselLineUpLog() {
      try {
        await this.$store.dispatch('VesselLineUp/getVesselLineUpLog', this.$route.params.id || this.vesselLineUpId)
      } catch (e) {
        this.showFailedNotification(this, 'Failed to fetch VLU log, please try again')
      }
    },
    async submit() {
      if (this.validate()) {
        this.showFailedNotification(this, 'Some fields is empty, please fill it first')
        return
      }

      try {
        if (this.isCreate()) {
          this.isBusy = true
          await this.$store.dispatch('VesselLineUp/submitVesselLineUp', {
            form: this.transformFormToData(),
            isCreate: true
          })
          this.isBusy = false
        } else {
          this.isBusy = true
          const form = { ...this.transformFormToData(), reason: this.reason }
          Object.keys(form).forEach(key => {
            if (typeof form[key] === 'object' && form[key]) {
              Object.keys(form[key]).forEach(subKey => {
                if (form[key][subKey] === this.vesselLineUpDetail[key][subKey]) {
                  delete form[key][subKey]
                }
              })
              if (this.isEmpty(form[key])){
                delete form[key]
              }
            } else {
              if (form[key] === this.vesselLineUpDetail[key]) {
                delete form[key]
              }
            }
          })
          await this.$store.dispatch('VesselLineUp/submitVesselLineUp', {
            id: this.$route.params.id || this.vesselLineUpId,
            form: form,
            isCreate: false
          })
          this.isBusy = false
          this.isEditReasonModalShown = false
        }
        this.popUp = true
      } catch (e) {
        this.isBusy = false
        this.showFailedNotification(
          this,
          `Failed to ${this.isCreate() ? 'submit' : 'update'} VLU, please try again`
        )
      }
    },
    isCreate() {
      return this.$route.path.split('/')[3] === 'create'
    },
    isDetail() {
      return this.$route.path.split('/')[3] === 'detail'
    },
    transformDataToForm(val) {
      this.form[6].inputField = []
      for (const [key, value] of Object.entries(val)) {
        if (typeof value === 'object' && value) {
          for (const [keyField, valueField] of Object.entries(value)) {
            this.dataToForm(keyField, valueField, key)
            if (key === 'third_party') {
              this.form[6].inputField.push({
                key: keyField,
                title: this.toUpper(keyField),
                isFreeInput: true,
                isNumber: true,
                haveUnit: true,
                isDisabled: true,
                canSearch: false,
                placeholder: null,
                value: valueField || 0
              })
            }
          }
        } else {
          this.dataToForm(key, value)
        }
      }
    },
    dataToForm(key, value, parentKey) {
      const index = this.form.findIndex(item => {
        if (parentKey && item.key === parentKey) {
          return item.inputField.find(field => field.key === key)
        }
        return item.inputField.find(field => !parentKey && field.key === key)
      })
      if (index > -1) {
        const indexField = this.form[index].inputField.findIndex(item => (
          item.key === key
        ))
        this.form[index].inputField[indexField].value =
          this.putOutOrFormatValue(this.form[index].inputField[indexField], value)
      }
    },
    transformFormToData() {
      const form = {}
      this.form.forEach(item => {
        if (item.key) {
          const itemTemp = {}
          item.inputField.forEach(field => {
            if (field.key !== 'loading_plan') {
              itemTemp[field.key] = this.putOutOrFormatValue(field, field.value, true)
            }
          })
          form[item.key] = itemTemp
        } else {
          item.inputField.forEach(field => {
            form[field.key] = this.putOutOrFormatValue(field, field.value, true)
          })
        }
      })
      const endUser = this.options.end_user.find(item => item.text === form.end_user)
      return {
        ...form,
        sos_detail_id: endUser ? endUser.sos_list_id : this.vesselLineUpDetail.sos_detail_id
      }
    },
    putOutOrFormatValue(field, value, isDefaultFormat = false) {
      if (field.isDate) {
        return value
          ? isDefaultFormat
            ? this.moment(value, [field.format]).utc().toISOString()
            : this.moment(value).format(field.format)
          : value
      }
      if (field.isNumber) {
        return value ? parseFloat(value) : 0
      }
      if (field.key === 'loading_plan') {
        return !this.isEmpty(value)
          ? value.map(item =>
            this.moment(item).format(field.format)
          )
          : value
      }
      return value
    },
    pageSubTitle() {
      if (this.isCreate()) {
        return 'Add'
      }
      return this.startCase(this.$route.path.split('/')[3])
    },
    disabledDate(key, date) {
      switch (key) {
        case 'expected_month':
          return date < this.moment().subtract(1, 'months')
        case 'estimate_time_arrival':
          return date < this.moment().subtract(1, 'days')
        default:
          return !date
      }
    },
    disabledTime(key, date, value) {
      if (key === 'complete_loading') {
        const commenceLoading = this.moment(this.form[0].inputField[11].value, ['DD-MMM-YYYY'])
        const completeLoading = this.moment(value, ['DD-MMM-YYYY'])
        if (completeLoading.isSame(commenceLoading)) {
          return !this.moment(date)
            .isAfter(
              this.moment(this.form[0].inputField[11].value, ['DD-MMM-YYYY HH:mm']).add(1, 'minutes')
            )
        }
      }
      return !date
    },
    validate() {
      Object.keys(this.form).forEach(key => {
        if (this.form[key].inputField.length) {
          this.form[key].inputField.forEach(inputField => {
            if (inputField.hasOwnProperty('isValid')) {
              inputField.isValid = !!inputField.value
            }
          })
        }
      })

      return Object.keys(this.form).some(key => !(
        !this.form[key].inputField.length
          ? true
          : this.form[key].inputField.some(inputField => (
            !inputField.hasOwnProperty('isValid')
              ? true
              : inputField.isValid
          ))
      ))
    }
  }
}
</script>

<style lang="scss" scoped>
.divider {
  border: 1px solid #CDC6E1;
  width: 1px;
}

.mx-min-3 {
  margin-right: -0.75rem;
  margin-left: -0.75rem;
}

.mt-min-4 {
  margin-top: -1rem;
}

.button {
  @apply py-4 #{!important};
  @apply rounded-lg;
  @apply border-2;
  @apply font-semibold;
  @apply min-w-button;
  @apply text-base;
  height: calc( 1rem * 10 / 3 );

  &.shadow-secondary {
    -webkit-box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary),1);
    box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary),1);
  }

  &:focus {
    @apply outline-none;
  }
}

/deep/.modal-content-container {
  width: unset;
  height: unset;
  min-width: 30%;
}

/deep/.modal-content-body {
  @apply pt-3;
  @apply px-8;
  span {
    @apply mb-1;
  }

  .vs-textarea {
    @apply bg-white;
    min-height: 6.33rem;
  }
}

/deep/.modal-content-footer {
  @apply px-8;
  @apply pt-16;
}

.is-not-valid {
  /deep/.vs-con-input,
  /deep/.mx-input-wrapper,
  /deep/.bg-accent-multiselect {
    @apply rounded-lg;
    outline: 2px solid #ff647c;
  }
}
</style>
